import { getField, updateField } from "vuex-map-fields";
import * as actions from "./actions";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    screensVisibility: {},
    fieldsVisibility: {},
    fieldValues: {},
    activeScreen: 0,
    debug: false,
    review_visible: false,
    review_index: null,
    loan_type: null,
    passed_params: {},
    logo: null,
    fieldsVisibilityVersion: 0,
    screensVisibilityVersion: 0
  },
  actions,
  getters: {
    getField,
  },
  mutations: {
    updateField,
    ...mutations,
  },
};
